import React from 'react';
import IconUpcoming from '@/assets/icons/upcoming.svg';

function Upcoming() {
    return (
        <div className='mt-4 text-center flex flex-col items-center'>
            <img src={IconUpcoming} alt="Upcoming" className='w-[14.3rem] h-[16.6rem]' />
            <p className='font-inter font-semibold text-xl mb-2'>Coming soon</p>
            <p className='font-inter text-sm'>We’re cooking up! Check back for updates here.</p>
        </div>
    );
}

export default Upcoming;